// Product.js
// Component for Product Entry

// Imports
import React from 'react';
import { ControlGroup } from '@blueprintjs/core';
import { Colors } from "@blueprintjs/core";
import PropTypes from 'prop-types';
import EditableText from '../Common/EditableText';
import RemoveButton from '../Common/RemoveButton';
import Unit from './Unit';

// Component Class
// Shows Product entry
class Product extends React.Component {
  // Renames the Product
  rename = (name) => {
    this.props.rename(this.props.product.id, name);
  };

  // Removes the Product
  remove = () => {
    this.props.remove(this.props.product.id);
  }

  // Add a unit
  addUnit = () => {
    this.props.addUnit(this.props.product.id, "unidade");
  }
  
  // Remove a unit with the given id
  removeUnit = (id) => {
    this.props.removeUnit(this.props.product.id, id);
  }

  // Renames the unit with the given id
  renameUnit = (id, name) => {
    this.props.renameUnit(this.props.product.id, id, name);
  }

  // Sets unitary price for the given unit
  setUnitPrice = (id, price) => {
    this.props.setUnitPrice(this.props.product.id, id, price);
  }

  // Renders Component
  render() {
    var lineStyle = this.props.order > 0 ? {backgroundColor: Colors.GREEN5} : null;
    return (
      <tr style={{verticalAlignment: 'middle', ...lineStyle}}>
        <td><EditableText value={this.props.product.name} placeholder="Nome do Produto" rename={this.rename} /></td>
        <td>
          <ControlGroup fill vertical>
            {this.props.product.price.map((price, id) =>
              <Unit
                key={id}
                id={id}
                unit={price}
                add={this.addUnit}
                remove={this.removeUnit}
                rename={this.renameUnit}
                setPrice={this.setUnitPrice}
              />
            )}
          </ControlGroup>
        </td>
        <td>
          <center>
            <RemoveButton
              itemName={this.props.product.name}
              confirmation="Você tem certeza que deseja remover este produto?"
              remove={this.remove}
            />
          </center>
        </td>
      </tr>
    );
  }
}

// Required Properties
Product.propTypes = {
  product: PropTypes.object.isRequired,
  order: PropTypes.object,
  rename: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  addUnit: PropTypes.func.isRequired,
  removeUnit: PropTypes.func.isRequired,
  renameUnit: PropTypes.func.isRequired,
  setUnitPrice: PropTypes.func.isRequired,
}

// Exports
export default Product;


// WEBPACK FOOTER //
// ./src/components/ProductView/Product.js